import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import { useAppSelector } from '../../../redux/store';

import { fetchSingleAdminUser } from '@actions/adminUsers/fetchSingleAdminUser';
import {
    getAdminUser,
    getAdminUserPostSuccess,
    // getAdminUsersError
} from '@selectors/adminUsers';

import AdminUser from './AdminUser';

import UpdateAdminPasswordModal from './UpdateAdminPasswordModal';
import DeleteAdminModal from './DeleteAdminModal';
import UpdateAdminModal from '../adminUsers/UpdateAdminModal';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';
import useRoles from 'lib/src/hooks/useRoles';
import RevokeAdminMfaModal from './RevokeAdminMfaModal';
import usePrevious from 'lib/src/hooks/usePrevious';

const AdminUserContainer: React.FC = () => {
    const dispatch = useDispatch();
    const { id, action } = useParams<{ id: string; action?: string }>();

    const postSuccess = useSelector(getAdminUserPostSuccess);
    const prevSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (postSuccess && !prevSuccess) dispatch(fetchSingleAdminUser(+id));
    }, [postSuccess, prevSuccess, id, dispatch]);

    useEffect(() => {
        dispatch(fetchSingleAdminUser(+id));
    }, [id, dispatch]);

    // const error = useSelector(getAdminUsersError);
    const user = useAppSelector(state => getAdminUser(state, +id));
    const history = useHistory();
    const closeModal = useCallback(() => {
        history.replace(`/admins/${id}`);
    }, [history, id]);

    const userAccessRoles = useRoles();
    const hasSuperAdminAccess = userAccessRoles.includes(userRoles.superAdmin);

    return (
        <>
            <AdminUser user={user} hasSuperAdminAccess={hasSuperAdminAccess} />
            {action === 'delete' && <DeleteAdminModal user={user} />}
            {!!user && action === 'edit-password' && <UpdateAdminPasswordModal user={user} />}
            {!!user && action === 'edit' && (
                <UpdateAdminModal user={user} closeModal={closeModal} />
            )}
            {hasSuperAdminAccess && !!user && user.hasMfa && action === 'revoke-mfa' && (
                <RevokeAdminMfaModal user={user} />
            )}
        </>
    );
};

export default AdminUserContainer;
